import { Stack, StackProps } from "@mui/material";

export function Row(props: Omit<StackProps, "direction">) {
  return <Stack direction="row" {...props} />;
}
